import React from 'react'
import styles from './tool-suite.module.scss'
import { tools } from './tool-suite-content'
import { ToolCTA } from './tool-cta'

export const ToolSuiteComponent: React.FC = () => {
  return (
    <div className={styles.container}>
      {tools.map(({ text, icon, slug, name }) => (
        <ToolCTA key={name} text={text} icon={icon} slug={slug} name={name} />
      ))}
    </div>
  )
}
